import { NgModule } from '@angular/core';

import { TdisstudioSharedLibsModule, JhiAlertComponent, JhiAlertErrorComponent } from './';

@NgModule({
    imports: [TdisstudioSharedLibsModule],
    declarations: [JhiAlertComponent, JhiAlertErrorComponent],
    exports: [TdisstudioSharedLibsModule, JhiAlertComponent, JhiAlertErrorComponent]
})
export class TdisstudioSharedCommonModule {}
